export default __webpack_public_path__ + "static/media/paycor_developer_portal.59a72c44.svg";